import { useEffect } from 'react';

import { TOKEN_SCOPE, usePostRecentRegion, useServiceAppState } from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

/**
 * 콘솔 입장시 현재 리전으로 최근 접속리전을 최신화합니다.
 */
const useRecentRegionEffect = () => {
  const {
    state: { region, status, scope },
  } = useServiceAppState();

  const { mutate } = usePostRecentRegion();
  useEffect(() => {
    if (status !== STATUS_CODE.OK) return;

    if (scope !== TOKEN_SCOPE.PROJECT) return;

    if (!region) return;
    mutate({ region });
  }, [mutate, region, scope, status]);
};

export default useRecentRegionEffect;
